import { all } from 'redux-saga/effects';

import { loginSaga, loginCheckSaga, logoutSaga, pwResetSaga, pwResetRequestSaga, settingPasswordSaga, pwInitSaga } from './login';
import { getRecordListSaga, getRecordHistorySaga, deleteRecordSaga, saveRecordSaga, sendRecordSaga, saveCommentSaga, sendCommentSaga, getCommentListSaga } from './record';
import { getSubjectListSaga, setSubjectSaga, deleteSubjectSaga, changeReleaseSubjectSaga, changeOrderSaga } from './subject';
import { getVocabularyListSaga, setVocabularySaga, deleteVocabularySaga } from './vocabulary';
import { getChunkListSaga, setChunkSaga, deleteChunkSaga } from './chunk';
import { getUserListSaga, setUserSaga, deleteUserSaga, restoreUserSaga, importUsersSaga, getSendCountSaga, getShadowingSendSaga } from './user';
import { getNoticeListSaga, sendNoticeSaga, deleteNoticeSaga, readNoticeSaga } from './notice';
import { getCourseInfoSaga, uploadAudioSaga, downloadAudioSaga, checkMaintenanceSaga, uploadPictureEnSaga, downloadPictureEnSaga } from './other';
import { setStudyStateSaga, setFavSubjectSaga } from './subjectUserStatus';
import { setWeeksGoalSaga, getWeeksGoalSaga, setIsLimitedSubjectSetSaga } from './home';
import { getWebinarArchiveReadSaga, setWebinarArchiveReadSaga, getWebinarArchiveListSaga } from './webinarArchive';
import { getWebinarInfoReadSaga, setWebinarInfoReadSaga, getContentListSaga } from './content';
import { getFaqListSaga } from './faq';

const saga = [
    loginSaga,
    loginCheckSaga,
    logoutSaga,
    pwResetSaga,
    pwResetRequestSaga,
    settingPasswordSaga,
    pwInitSaga,

    getRecordListSaga,
    getRecordHistorySaga,
    deleteRecordSaga,
    saveRecordSaga,
    sendRecordSaga,
    saveCommentSaga,
    sendCommentSaga,
    getCommentListSaga,

    getSubjectListSaga,
    setSubjectSaga,
    deleteSubjectSaga,
    changeReleaseSubjectSaga,
    changeOrderSaga,

    getVocabularyListSaga,
    setVocabularySaga,
    deleteVocabularySaga,

    getChunkListSaga,
    setChunkSaga,
    deleteChunkSaga,

    getUserListSaga, 
    setUserSaga,
    deleteUserSaga,
    restoreUserSaga,
    importUsersSaga,
    getSendCountSaga,
    getShadowingSendSaga,

    getNoticeListSaga, 
    sendNoticeSaga, 
    deleteNoticeSaga,
    readNoticeSaga,

    getCourseInfoSaga,
    uploadAudioSaga,
    downloadAudioSaga,
    checkMaintenanceSaga,
    uploadPictureEnSaga,
    downloadPictureEnSaga,

    setStudyStateSaga,
    setFavSubjectSaga,

    setWeeksGoalSaga,
    getWeeksGoalSaga,
    setIsLimitedSubjectSetSaga,

    getWebinarArchiveReadSaga,
    setWebinarArchiveReadSaga,
    getWebinarArchiveListSaga,

    getWebinarInfoReadSaga,
    setWebinarInfoReadSaga,
    getContentListSaga,

    getFaqListSaga,

];

export default function* rootSaga() {
    yield all([...saga]);
}
